import type { ButtonHTMLAttributes, PropsWithChildren } from "react";

type ButtonVariant = "primary" | "secondary" | "quiet";

type ButtonProps = PropsWithChildren<
  ButtonHTMLAttributes<HTMLButtonElement> & {
    variant?: ButtonVariant;
    fullWidth?: boolean;
  }
>;

export function Button({
  children,
  className = "",
  variant = "primary",
  fullWidth = false,
  type = "button",
  ...props
}: ButtonProps) {
  return (
    <button
      className={`button button--${variant}${variant === "primary" ? " primary-glass-button" : ""}${fullWidth ? " button--full" : ""} ${className}`}
      type={type}
      {...props}
    >
      <span className="button__label">{children}</span>
    </button>
  );
}
